// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"143":"4cc93045","879":"92f5cc77"}[chunkId] + ".js";
};